module.exports = __webpack_public_path__ + "img/image-mockups.edc63e85.png";